import { useEffect, useMemo, useState } from "react";
import { filterObjectByKeys, disabledFilterTooltipTitle } from "./DreamSearchFilter";
import debounce from "lodash/debounce";
import { useDreamSearchContext } from "../../../DreamSearchContext";
import { programTagFriendlyMap } from "@portal/app/_common/data/enumValueMaps";
import { EnumMultiSelectChipFilter } from "@portal/app/manage/_components/DreamTable";
import isEmpty from "lodash/isEmpty";
import { FilterComponentProps } from "./DreamSearchFilter";

export const ProgramTagsFilterComponent = ({
  value,
  setValue,
  setHasOptions,
}: FilterComponentProps<GQL.ProgramTag[]>) => {
  const { filterSettings } = useDreamSearchContext();
  const [localValue, setLocalValue] = useState<GQL.ProgramTag[]>(value);
  const [availableOptions] = useState(
    filterObjectByKeys(programTagFriendlyMap, filterSettings?.programTag)
  );

  const debounceSetValue = useMemo(
    () => debounce((localValue: GQL.ProgramTag[]) => setValue(localValue), 500),
    [setValue]
  );

  useEffect(() => {
    if (filterSettings) {
      setHasOptions(Object.keys(availableOptions).length > 0);
    }
  }, [availableOptions, filterSettings, setHasOptions]);

  return (
    <EnumMultiSelectChipFilter<GQL.ProgramTag>
      label="Program tags"
      value={localValue}
      id="program-tags"
      setValue={(value) => {
        const newValue = isEmpty(value) ? null : value;
        setLocalValue(newValue);
        debounceSetValue(newValue);
      }}
      enumToFriendlyMap={availableOptions}
      disabledTooltipTitle={disabledFilterTooltipTitle}
    />
  );
};
